import { forms } from "./elements";
import { submit } from "./submit";

for (const formName in forms) {
    if (Object.hasOwnProperty.call(forms, formName)) {
        const form = forms[formName];
        form?.addEventListener("submit", submit);
    }
}
